import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import style from "../styles.module.scss";

import { DndProvider, useDrop, useDrag } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import { useSelector } from "react-redux";
import axios from 'util/axios';
import { useTranslation } from "react-i18next";

import Row from "../datatable/DataTable";

import update from "immutability-helper";

import ModalPortal from "util/component/Modal";
import { Modal, ConfirmWithMessage } from "util/component/Modal/Modal";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faTableList, faSquare } from "@fortawesome/free-solid-svg-icons";

const post = async ({ api, body, message }, getFunc, onError) => {
    const response = await axios.post(process.env.REACT_APP_API + api, { ...body, message })
        .catch(e => ({ ...e.response }))
    if (response.status.toString() === "200") {
        if (response.data.data.result?.toString().includes("ERR")) {
            onError(response.data.data.result.toString());
        } else {
            getFunc && getFunc();
        }
    } else {
        onError("Server Code : " + response.status.toString());
    }
};

const ParaUnit = () => {
    const { t } = useTranslation(["page"]);
    const user = useSelector((store) => store.user);
    const mTable = useSelector((store) => store.masterTable);

    const [Filter, SetFilter] = useState("");

    const [TableData, SetTableData] = useState([]);
    const [TableData2, SetTableData2] = useState([]);

    const ModalMessage = useRef(null);
    const tempData = useRef(null);

    const rendering = !!mTable.proc && mTable.proc.match(/(USP|DSP)/) && !mTable.subtype.match(/(SP|OPT)/);

    const [ModalOpen, SetModalOpen] = useState(false);

    const canOrder = useRef(false);

    const orderByRef = useRef(0);

    const onError = (message) => {
        ModalMessage.current = t(message);
        SetModalOpen("modal");
    }

    const getUnit = async () => {
        const response = await axios.post(process.env.REACT_APP_API + "/common/retrieveMasterCodeList", { grcd: "UNIT" });
        const data = response.data.data.result;
        SetModalOpen(false);
        SetTableData(data);
    };

    const getData2 = async () => {
        const response = await axios.post(process.env.REACT_APP_API + "/pcsCreate/retrieveUnitList", { pacd: mTable.paraCd });
        const data = response.data.data.result;
        canOrder.current = false;
        let orderBy;

        try {
            if (data.length < 2) {
                orderBy = data.length + 1;
            } else {
                const orderByNum = data.reduce((prev, value) => {
                    return prev.orderBy >= value.orderBy ? prev.orderBy : value.orderBy;
                });
                orderBy = parseInt(orderByNum) + 1;
            }
        } catch (e) {
            orderBy = 1;
        }

        if (isNaN(orderBy)) orderBy = 1;
        orderByRef.current = orderBy;

        SetTableData2(data);
    };

    const deleteParaUnit = (item) => {
        tempData.current = {
            api: "/common/removeParaUnitCode",
            body: {
                paraCd: mTable.paraCd,
                unitCd: item.unitCd,
                userId: user.userId,
            },
        };

        ModalMessage.current = t("deleteConfirm");
        SetModalOpen("confirm");
    }

    const setOrderBy = () => {
        let newD = TableData2.map((v, i) => {
            return {
                paraCd: mTable.paraCd,
                unitCd: v.unitCd,
                orderBy: i + 1,
                userId: user.userId,
            };
        });
        tempData.current = {
            api: "/common/modifyParaUnitCodeOrderBy",
            body: { master: newD },
        };

        ModalMessage.current = t("ChangeOrderConfirm");
        SetModalOpen("confirm");
    };

    const insertParaUnit = (item, dropResult) => {
        if (!!!dropResult.name) {
            return;
        }
        tempData.current = {
            api: "/common/createParaUnitCode",
            body: {
                paraCd: dropResult.name,
                unitCd: item.code,
                userId: user.userId,
                orderBy: dropResult.orderBy,
            },
        };
        ModalMessage.current = t("registerConfirm");
        SetModalOpen("confirm");
    };

    const moveRow = useCallback((dragIndex, hoverIndex) => {
        canOrder.current = true;
        SetTableData2((D) =>
            update(D, {
                $splice: [
                    [dragIndex, 1],
                    [hoverIndex, 0, D[dragIndex]],
                ],
            })
        );
    }, []);

    const renderTable = useMemo(() => {

        const row = TableData.map((v, i) => {
            if (v.label.toString().toLowerCase().includes(Filter.toLowerCase()) || v.code.toString().toLowerCase().includes(Filter.toString().toLowerCase())) {
                return <UnitRow key={"paraUnitList" + i} data={v} callBack={insertParaUnit} hide={false} />;
            } else {
                return <UnitRow key={"paraUnitList" + i} data={v} callBack={insertParaUnit} hide={true} />;
            }

        });
        return row;
    }, [TableData, Filter]);

    const renderTwo = useMemo(() => {
        if (!!mTable.paraCd) {
            if (TableData2.length > 0) {
                return TableData2.map((v, i) => {
                    return <ParaUnitMatchRow key={"paraUnitMatch" + i} data={v} index={i} moveRow={moveRow} deleteRow={deleteParaUnit} admin={user.isAdmin} />;
                });
            } else {
                return <tr>
                    <td colSpan={user.isAdmin ? 4 : 3} style={{ padding: "20px 5px", textAlign: "center" }}>
                        No Unit...
                    </td>
                </tr>
            }
        } else {
            return (
                <tr>
                    <td colSpan={user.isAdmin ? 4 : 3} style={{ padding: "20px 5px", textAlign: "center" }}>
                        Select Parameter
                    </td>
                </tr>
            );
        }

    }, [TableData2]);

    useEffect(() => {
        getUnit();
        return () => {
            SetTableData([]);
        };
    }, []);

    useEffect(() => {
        if (!!mTable.paraCd) getData2();
        else SetTableData2([]);
    }, [mTable.paraCd]);

    const ModalRender = useMemo(() => {
        const confirmValid = () => {
            return true;
        };
        const onConfirm = async (message) => {
            await post({ ...tempData.current, message }, getData2, onError);

        };

        if (!ModalOpen) {
            tempData.current = null;
            return null;
        } else {
            if (ModalOpen === "confirm") {
                return (
                    <ConfirmWithMessage onClose={() => SetModalOpen(false)} valid={confirmValid} onConfirm={(message) => onConfirm(message)}>
                        <p>{ModalMessage.current}</p>
                    </ConfirmWithMessage>
                );
            } else {
                return <Modal onClose={() => SetModalOpen(false)}>{ModalMessage.current}</Modal>;
            }
        }
    }, [ModalOpen]);

    if (!rendering) {
        return <section></section>
    } else {
        return (
            <section>
                <div className={`${style.paraUnitTableBox}`}>
                    <DndProvider backend={HTML5Backend}>
                        <DropBox canDropProp={mTable.paraCd} lastOrder={orderByRef.current}>
                            <table className={`${style.paraUnitTable} ${user.isAdmin ? "admin" : ""}`}>
                                <colgroup>
                                    <col width="40px" />
                                    <col width="50px" />
                                    <col width="130px" />
                                    {
                                        user.isAdmin && <col width="60px" />
                                    }

                                </colgroup>
                                <thead>
                                    <tr>
                                        <th colSpan={user.isAdmin ? 4 : 3}>{`Parameter <-> Unit`}</th>
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <th>Code</th>
                                        <th>Unit</th>
                                        {
                                            user.isAdmin && <th>

                                                <button disabled={!canOrder.current} style={{ fontSize: "0.8rem" }} className={style.order}
                                                    onClick={setOrderBy}
                                                >
                                                    {t("ChangeOrder")}
                                                </button>
                                            </th>
                                        }

                                    </tr>
                                </thead>
                                <tbody>{renderTwo}</tbody>
                            </table>
                        </DropBox>
                        {
                            user.isAdmin && <>

                                <div style={{ paddingTop: "100px" }}>
                                    <div style={{ position: "sticky", top: "100px" }}>
                                        <div style={{ display: "flex", flexWrap: "nowrap", gap: "5px" }}>
                                            <FontAwesomeIcon icon={faTableList} style={{ fontSize: "1.5rem" }} />
                                            <FontAwesomeIcon icon={faArrowLeft} style={{ fontSize: "1.5rem" }} />
                                            <FontAwesomeIcon icon={faSquare} style={{ fontSize: "1.5rem" }} />
                                        </div>
                                    </div>
                                </div>
                                <div style={{ borderBottom: "1px solid #000" }}>
                                    <table className={`${style.paraUnitUnitList}`}>
                                        <colgroup>
                                            <col width="50px" />
                                            <col width="130px" />
                                        </colgroup>
                                        <thead style={{ position: "sticky", zIndex: "10", top: "0" }}>
                                            <tr>
                                                <th colSpan="3">{`Unit List`}</th>
                                            </tr>
                                            <tr>
                                                <th>Code</th>
                                                <th>Unit</th>
                                            </tr>
                                            <tr className={`${style.filter}`}>
                                                <td colSpan="2">
                                                    <input placeholder="Filter" value={Filter} onChange={(e) => SetFilter(e.target.value)} style={{ border: "none" }} />
                                                </td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {renderTable}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        }
                    </DndProvider>
                </div>
                {!!ModalOpen && <ModalPortal>{ModalRender}</ModalPortal>}
            </section>
        );
    }

};

const ParaUnitMatchRow = ({ data, index, moveRow = () => { }, deleteRow = () => { }, admin = false }) => {
    const _Ref = React.useRef(null);
    const { t } = useTranslation(["page"]);

    // const startIndex = React.useRef(null);

    const [, drop] = useDrop({
        type: "row",
        accept: "row",
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            };
        },
        hover(item, monitor) {
            if (!_Ref.current) {
                return;
            }
            const dragIndex = item.index;
            const hoverIndex = index;
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return;
            }
            // Determine rectangle on screen
            const hoverBoundingRect = _Ref.current.getBoundingClientRect();
            // Get vertical middle
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            // Determine mouse position
            const clientOffset = monitor.getClientOffset();
            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }
            // Time to actually perform the action
            // moveRow(code, dragIndex, hoverIndex)
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.

            moveRow(dragIndex, hoverIndex);
            item.index = hoverIndex;
        },
    });

    const [{ isDragging }, drag] = useDrag({
        type: "row",
        item: () => {
            return { index };
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    admin && drag(drop(_Ref));

    return (
        <tr ref={_Ref}>
            <td>{data.orderBy}</td>
            <td>{data.unitCd}</td>
            <td>{data.label}</td>
            {
                admin && <td>
                <button className={`${style.tBtn} ${style.danger}`} onClick={() => deleteRow(data)}>{t("deleteMsg")}</button>
            </td>
            }
            
        </tr>
    );
};

const DropBox = ({ children, canDropProp, lastOrder }) => {
    const [{ canDrop, isOver }, drop] = useDrop(
        () => ({
            accept: "box",
            drop: () => ({ name: canDropProp, orderBy: lastOrder }),
            collect: (monitor) => ({
                isOver: monitor.isOver(),
                canDrop: monitor.canDrop(),
            }),
        }),
        [canDropProp, lastOrder]
    );

    const isActive = canDrop && isOver && !!canDropProp;
    let style = { position: "sticky", top: 0 };
    if (isActive) {
        style = { ...style, backgroundColor: "#81c6e6" };
    } else if (canDrop && !!canDropProp) {
        style = { ...style, backgroundColor: "#cce3ed" };
    }
    return (
        <div data-testid="dustbin">
            <div style={style} ref={drop}>
                {children}
            </div>
        </div>
    );
};

const UnitRow = ({ data, callBack, hide }) => {
    const [, drag] = useDrag(() => ({
        type: "box",
        item: data,
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult();
            if (item && dropResult) {
                callBack(item, dropResult);
            }
        },
        collect: (monitor) => {
            return {
                isDragging: monitor.isDragging(),
                handlerId: monitor.getHandlerId(),
            }
        },
    }));

    return (
        <tr ref={drag} style={hide ? { display: "none" } : {}} >
            <td>{data.code}</td>
            <td>{data.label}</td>
        </tr>
    );
};

export default React.forwardRef(ParaUnit);
